import React, { useEffect, useRef, useState } from 'react';

import ButtonCustom from 'components/buttonCustom';
import UseChatbotProfile from './useChatbotProfile';
import { Main, Title, TitleIcon, Inner, BtnGroup, IconCustom } from './Styled';
import {
    IconButton,
    Box,
    Container,
    TextField,
    InputAdornment,
    TableCell,
    TableRow,
    TableHead,
    Typography,
    Paper,
} from '@mui/material';
import { Button, Table, TableBody } from '@material-ui/core';
import ComunImg from './images/talk.png';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'; // Import for "Alterar empresa"

import Loading from 'components/loading';

const ChatbotProfile = () => {
    const {
        chatProfiles,
        currentPage,
        totalPages,
        fetchChatProfile,
        transitionIn,
        goLink,
        fetchProfileSearch,
        loadingPage,
        clienteSelecionado,
        fetchClienteSearch,
        empresasList,
        setClienteSelecionado,
        setChatProfiles,
        criarPerfilChat,
        removerPerfilChat,
        chatProfile,
        obterProfile,
        profile,
    } = UseChatbotProfile();

    function useDebounce(value, delay) {
        const [debouncedValue, setDebouncedValue] = useState(value);

        useEffect(() => {
            const handler = setTimeout(() => {
                setDebouncedValue(value);
            }, delay);

            return () => {
                clearTimeout(handler);
            };
        }, [value, delay]);

        return debouncedValue;
    }

    const [search, setSearch] = useState('');
    const [searchCliente, setSearchCliente] = useState('');

    const debouncedSearchCliente = useDebounce(searchCliente, 20);
    const debouncedSearch = useDebounce(search, 20);

    const habilitarListarUsuarios = () => {
        return !!clienteSelecionado;
    };

    const removerNivelAcesso = async (userId, nivel, ausencia) => {
        const sucesso = await removerPerfilChat(userId, clienteSelecionado, nivel, ausencia);

        // Se a operação no servidor foi bem-sucedida, atualiza o estado da interface.
        if (sucesso) {
            //dados extraidos da função do hook
            setChatProfiles((prevProfiles) =>
                prevProfiles.map((profile) => {
                    if (profile.pess_id_pessoa === userId) {
                        const updatedProfile = { ...profile };
                        if (nivel === 0) {
                            // Remove completamente o perfil do chatbot
                            updatedProfile.chatbot_perfil = null;
                        } else {
                            // Atualiza apenas os valores específicos
                            if (!updatedProfile.chatbot_perfil) {
                                updatedProfile.chatbot_perfil = {};
                            }
                            updatedProfile.chatbot_perfil = {
                                ...updatedProfile.chatbot_perfil,
                                nivel_acesso: nivel,
                                ausencia: ausencia,
                            };
                        }
                        return updatedProfile;
                    }
                    return profile;
                }),
            );
        } else {
            console.error('Falha ao remover o perfil no servidor. A interface não foi alterada.');
            alert('Não foi possível remover o nível de acesso. Tente novamente.');
        }
    };

    const adicionarNivelAcesso = async (userId, nivel, ausencia) => {
        const sucesso = await criarPerfilChat(userId, clienteSelecionado, nivel, ausencia);

        // Se a operação no servidor foi bem-sucedida, atualiza o estado.
        if (sucesso) {
            //dados extraidos da função do hook
            setChatProfiles((prevProfiles) =>
                prevProfiles.map((profile) => {
                    if (profile.pess_id_pessoa === userId) {
                        const updatedProfile = { ...profile };
                        if (!updatedProfile.chatbot_perfil) {
                            updatedProfile.chatbot_perfil = {};
                        }
                        updatedProfile.chatbot_perfil = {
                            ...updatedProfile.chatbot_perfil,
                            nivel_acesso: nivel,
                            ausencia: ausencia,
                        };
                        return updatedProfile;
                    }
                    return profile;
                }),
            );
        } else {
            console.error('Falha ao criar o perfil no servidor. A interface não foi alterada.');
            alert('Não foi possível alterar o nível de acesso. Tente novamente.');
        }
    };

    useEffect(() => {
        if (!habilitarListarUsuarios()) {
            fetchClienteSearch(debouncedSearchCliente);
        }
    }, [debouncedSearchCliente]);

    useEffect(() => {
        if (clienteSelecionado) {
            fetchProfileSearch(debouncedSearch);
        }
    }, [search, clienteSelecionado, debouncedSearch]);

    if (loadingPage) {
        return <Loading />;
    }

    return (
        <React.Fragment>
            {!habilitarListarUsuarios() && chatProfile.nivel_acesso > 0 && chatProfile.nivel_acesso === 1 && (
                <Main>
                    <Container>
                        <Title transition={transitionIn}>
                            {/*
                            <TitleIcon src={ComunImg} />
                            */}
                            Procurar empresa
                        </Title>
                        <Inner transition={transitionIn}>
                            <Paper
                                elevation={3}
                                sx={{
                                    p: { xs: 1, sm: 2 },
                                    borderRadius: '12px',
                                    backgroundColor: '#e6e6e6',
                                }}
                            >
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    {' '}
                                    {/* This Box wraps TextField and Table */}
                                    <TextField
                                        label="Procurar"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={searchCliente}
                                        onChange={(e) => setSearchCliente(e.target.value)}
                                        placeholder="Buscar empresa"
                                        sx={{
                                            mb: 2,
                                            backgroundColor: '#FFFFFF', // Added white background
                                            borderRadius: '20px', // Added rounded corners
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '20px', // Apply rounded corners to input root
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">🔍</InputAdornment>, // Changed to startAdornment like ChatbotSessionList
                                        }}
                                    />
                                    <Box sx={{ display: 'flex', justifyContent: 'right', mb: 2, mt: 1 }}>
                                        <IconButton
                                            onClick={() => goLink('/chat')}
                                            sx={{
                                                color: '#05f258', // Matching ChatbotSessionList icon color
                                                backgroundColor: '#FFFFFF', // Matching ChatbotSessionList icon background
                                                padding: '8px', // Matching ChatbotSessionList
                                                '&:hover': {
                                                    backgroundColor: 'rgba(0, 122, 255, 0.08)', // Matching ChatbotSessionList hover
                                                },
                                            }}
                                            title="Voltar"
                                        >
                                            <ArrowBackIcon sx={{ fontSize: '2rem' }} />
                                        </IconButton>
                                    </Box>
                                    <Table
                                        sx={{
                                            minWidth: 650,
                                            borderRadius: 2,
                                            overflow: 'hidden',
                                            boxShadow: 3,
                                            backgroundColor: '#fff',
                                        }}
                                    >
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                                <TableCell>
                                                    <strong>Id</strong>
                                                </TableCell>

                                                <TableCell>
                                                    <strong>Empresa</strong>
                                                </TableCell>

                                                <TableCell>
                                                    <strong>Definir Empresa</strong>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {empresasList.map((empresa, index) => (
                                                <TableRow
                                                    key={empresa?.clie_id_cliente}
                                                    sx={{
                                                        backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff',
                                                        '&:hover': {
                                                            backgroundColor: '#e0f7fa',
                                                            cursor: 'pointer',
                                                        },
                                                    }}
                                                >
                                                    <TableCell>{empresa?.clie_id_cliente}</TableCell>
                                                    <TableCell>{empresa?.clie_nome}</TableCell>
                                                    <TableCell>
                                                        <ButtonCustom
                                                            color={'primary'}
                                                            variant="contained"
                                                            onClick={() =>
                                                                setClienteSelecionado(empresa?.clie_id_cliente)
                                                            }
                                                            sx={{
                                                                borderRadius: 2,
                                                                fontWeight: 'bold',
                                                                textTransform: 'none',
                                                            }}
                                                        >
                                                            {'Adicionar empresa'}
                                                        </ButtonCustom>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Box>
                            </Paper>
                        </Inner>
                    </Container>
                </Main>
            )}
            {habilitarListarUsuarios() && chatProfile.nivel_acesso > 0 && (
                <Main>
                    <Container>
                        <Inner transition={transitionIn}>
                            <Title transition={transitionIn}>
                                {/*<TitleIcon src={ComunImg} />*/}
                                Lista de Usuários
                            </Title>
                            <Paper
                                elevation={3}
                                sx={{
                                    p: { xs: 1, sm: 2 },
                                    borderRadius: '12px',
                                    backgroundColor: '#e6e6e6',
                                }}
                            >
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    <TextField
                                        label="Procurar"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        placeholder="Buscar por usuário, empresa ou email"
                                        sx={{
                                            mb: 2,
                                            backgroundColor: '#FFFFFF', // Added white background
                                            borderRadius: '20px', // Added rounded corners
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '20px', // Apply rounded corners to input root
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">🔍</InputAdornment>, // Changed to startAdornment
                                        }}
                                    />
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mb: 2, mt: 1 }}>
                                        {chatProfile.nivel_acesso === 1 && (
                                            <IconButton
                                                onClick={() => setClienteSelecionado(null)}
                                                sx={{
                                                    color: '#05f258',
                                                    backgroundColor: '#FFFFFF',
                                                    padding: '8px',
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(0, 122, 255, 0.08)',
                                                    },
                                                }}
                                                title="Alterar empresa"
                                            >
                                                <SwapHorizIcon sx={{ fontSize: '2rem' }} />
                                            </IconButton>
                                        )}
                                        <IconButton
                                            onClick={() => goLink('/chat')}
                                            sx={{
                                                color: '#05f258',
                                                backgroundColor: '#FFFFFF',
                                                padding: '8px',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(0, 122, 255, 0.08)',
                                                },
                                            }}
                                            title="Voltar"
                                        >
                                            <ArrowBackIcon sx={{ fontSize: '2rem' }} />
                                        </IconButton>
                                    </Box>
                                    <Table
                                        sx={{
                                            minWidth: 650,
                                            borderRadius: 2,
                                            overflow: 'hidden',
                                            boxShadow: 3,
                                            backgroundColor: '#fff',
                                        }}
                                    >
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                                <TableCell>
                                                    <strong>Id Usuário</strong>
                                                </TableCell>

                                                <TableCell>
                                                    <strong>Usuário</strong>
                                                </TableCell>
                                                <TableCell>
                                                    <strong>Empresa</strong>
                                                </TableCell>
                                                <TableCell>
                                                    <strong>Perfil Ausência</strong>
                                                </TableCell>

                                                <TableCell>
                                                    <strong>Nivel Acesso</strong>
                                                </TableCell>
                                                <TableCell>
                                                    <strong>Ausência</strong>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {chatProfiles.map((profile, index) => (
                                                <TableRow
                                                    key={profile.pess_id_pessoa}
                                                    sx={{
                                                        backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff',
                                                        '&:hover': {
                                                            backgroundColor: '#e0f7fa',
                                                            cursor: 'pointer',
                                                        },
                                                    }}
                                                >
                                                    <TableCell>{profile.pess_id_pessoa}</TableCell>
                                                    <TableCell>{profile.pess_nome}</TableCell>
                                                    <TableCell>{profile.clie_nome}</TableCell>
                                                    <TableCell>
                                                        {profile.chatbot_perfil?.nivel_acesso === 1 ||
                                                        profile.chatbot_perfil?.nivel_acesso === 2
                                                            ? 'Administrador'
                                                            : 'Usuário'}
                                                    </TableCell>

                                                    <TableCell>
                                                        <ButtonCustom
                                                            color={'primary'}
                                                            variant="contained"
                                                            onClick={() =>
                                                                profile.chatbot_perfil?.nivel_acesso === 1 ||
                                                                profile.chatbot_perfil?.nivel_acesso === 2
                                                                    ? adicionarNivelAcesso(
                                                                          profile.pess_id_pessoa,
                                                                          0,
                                                                          profile.chatbot_perfil?.ausencia,
                                                                      )
                                                                    : adicionarNivelAcesso(
                                                                          profile.pess_id_pessoa,
                                                                          2,
                                                                          profile.chatbot_perfil?.ausencia,
                                                                      )
                                                            }
                                                            sx={{
                                                                borderRadius: 2,
                                                                fontWeight: 'bold',
                                                                textTransform: 'none',
                                                            }}
                                                        >
                                                            {profile.chatbot_perfil?.nivel_acesso === 1 ||
                                                            profile.chatbot_perfil?.nivel_acesso === 2
                                                                ? 'Remover nivel de acesso'
                                                                : 'Alterar nivel de Acesso'}
                                                        </ButtonCustom>
                                                    </TableCell>
                                                    <TableCell>
                                                        <ButtonCustom
                                                            color={'primary'}
                                                            variant="contained"
                                                            onClick={() =>
                                                                profile.chatbot_perfil?.ausencia === 1
                                                                    ? adicionarNivelAcesso(
                                                                          profile.pess_id_pessoa,
                                                                          profile.chatbot_perfil?.nivel_acesso,
                                                                          0,
                                                                      )
                                                                    : adicionarNivelAcesso(
                                                                          profile.pess_id_pessoa,
                                                                          profile.chatbot_perfil?.nivel_acesso,
                                                                          1,
                                                                      )
                                                            }
                                                            sx={{
                                                                borderRadius: 2,
                                                                fontWeight: 'bold',
                                                                textTransform: 'none',
                                                            }}
                                                        >
                                                            {profile.chatbot_perfil?.ausencia === 1
                                                                ? 'Remover Ausência'
                                                                : 'Alterar Ausência'}
                                                        </ButtonCustom>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Box>

                                <Box
                                    sx={{
                                        paddingTop: '10px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        paddingLeft: '10px',
                                        paddingRight: '10px',
                                        width: '100%',
                                    }}
                                >
                                    <Typography variant="body2" fontWeight="bold">
                                        Pagina: {currentPage}
                                    </Typography>
                                </Box>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        mt: 2,
                                        p: 1,
                                        backgroundColor: '#FFFFFF',
                                        borderRadius: '8px',
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={currentPage === 1}
                                        onClick={() => fetchChatProfile(currentPage - 1)}
                                        sx={{
                                            mr: 1,
                                            // backgroundColor, color, hover, and disabled styles
                                            // will now be handled by variant="contained" color="primary"
                                        }}
                                    >
                                        Anterior
                                    </Button>
                                    <Typography variant="body2" sx={{ mx: 2 }}>
                                        Página: {currentPage} de {totalPages}
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={currentPage === totalPages || totalPages === 0}
                                        onClick={() => fetchChatProfile(currentPage + 1)}
                                        sx={{
                                            ml: 1,
                                            // backgroundColor, color, hover, and disabled styles
                                            // will now be handled by variant="contained" color="primary"
                                        }}
                                    >
                                        Próxima
                                    </Button>
                                </Box>
                            </Paper>
                        </Inner>
                    </Container>
                </Main>
            )}
            {chatProfile.nivel_acesso === null && (
                <Main>
                    <Container>
                        <Inner transition={transitionIn}>
                            <Title transition={transitionIn}>Você não tem acesso</Title>
                            <Paper
                                elevation={3}
                                sx={{
                                    p: { xs: 1, sm: 2 },
                                    borderRadius: '12px',
                                    backgroundColor: '#e6e6e6',
                                }}
                            >
                                <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2, mt: 1 }}>
                                    <IconButton
                                        onClick={() => goLink('/chat')}
                                        sx={{
                                            color: '#05f258',
                                            backgroundColor: '#FFFFFF',
                                            padding: '8px',
                                            '&:hover': {
                                                backgroundColor: 'rgba(0, 122, 255, 0.08)',
                                            },
                                        }}
                                        title="Voltar"
                                    >
                                        <ArrowBackIcon sx={{ fontSize: '2rem' }} />
                                    </IconButton>
                                </Box>
                                {/* Content for no access */}
                                <Box sx={{ textAlign: 'center', mt: 2 }}>
                                    <Typography variant="body1">
                                        Você não possui o nível de acesso necessário para visualizar esta página.
                                    </Typography>
                                </Box>
                            </Paper>
                        </Inner>
                    </Container>
                    <Container>
                        <Title transition={transitionIn}>Você não tem acesso</Title>
                    </Container>
                </Main>
            )}

            {!habilitarListarUsuarios() && chatProfile.nivel_acesso === 2 && (
                <Main>
                    <Container>
                        <Inner transition={transitionIn}>
                            <Title transition={transitionIn}>Clique para gerenciar os usuários</Title>
                            <Paper
                                elevation={3}
                                sx={{
                                    p: { xs: 1, sm: 2 },
                                    borderRadius: '12px',
                                    backgroundColor: '#e6e6e6',
                                }}
                            >
                                <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2, mt: 1 }}>
                                    <IconButton
                                        onClick={() => goLink('/chat')}
                                        sx={{
                                            color: '#05f258',
                                            backgroundColor: '#FFFFFF',
                                            padding: '8px',
                                            '&:hover': {
                                                backgroundColor: 'rgba(0, 122, 255, 0.08)',
                                            },
                                        }}
                                        title="Voltar"
                                    >
                                        <ArrowBackIcon sx={{ fontSize: '2rem' }} />
                                    </IconButton>
                                </Box>
                                {/* Content for level 2 access */}
                                <Box sx={{ textAlign: 'center', mt: 2 }}>
                                    <ButtonCustom
                                        color={'primary'}
                                        variant="contained"
                                        onClick={() => setClienteSelecionado(profile.pess_id_cliente_principal)}
                                        sx={{
                                            borderRadius: 2,
                                            fontWeight: 'bold',
                                            textTransform: 'none',
                                        }}
                                    >
                                        {'Gerenciar usuarios'}
                                    </ButtonCustom>
                                </Box>
                            </Paper>
                        </Inner>
                    </Container>
                </Main>
            )}
        </React.Fragment>
    );
};

export default ChatbotProfile;
